import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchTopicLandingData = sectionName => {
    return doDefaultFetch(
        `/site/api/topic/${sectionName}` +
        `?include=section`
    );
};

export default {
    fetchTopicLandingData,
};